import { ElementProps, InputWrapperStylesNames, Radio, RadioGroupProps } from '@mantine/core';
import clsx from 'clsx';
import { useUnit } from 'effector-react';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { $language, changeLanguageFx } from 'shared/lib';
import { LANGUAGE_ICONS } from '../language-select';
import cls from './language-radio-group.module.scss';

export type LanguageRadioGroupProps = Omit<RadioGroupProps, 'children' | 'classNames'> &
	ElementProps<'div', keyof RadioGroupProps> & {
		classNames?: Partial<Record<InputWrapperStylesNames, string>>;
	};

export const LanguageRadioGroup = forwardRef<HTMLDivElement, LanguageRadioGroupProps>(
	({ classNames, ...props }, ref) => {
		const { t } = useTranslation();
		const [language, changeLanguage] = useUnit([$language, changeLanguageFx]);

		return (
			<Radio.Group
				ref={ref}
				label={t('viewer-menu.language')}
				value={language}
				classNames={{
					...classNames,
					root: clsx(cls.languageRadioGroup, classNames?.root),
					label: clsx(cls.languageRadioGroupLabel, classNames?.label),
				}}
				{...props}
			>
				{Object.entries(LANGUAGE_ICONS).map(([lng, Icon]) => (
					<Radio
						key={lng}
						label={
							<>
								<Icon className={cls.languageRadioGroupRadioIcon} /> {t(`languages.${lng}`)}
							</>
						}
						value={lng}
						labelPosition='left'
						classNames={{
							label: cls.languageRadioGroupRadioLabel,
							labelWrapper: cls.languageRadioGroupRadioLabelWrapper,
						}}
						onChange={() => changeLanguage(lng)}
					/>
				))}
			</Radio.Group>
		);
	},
);
